import { bytesToBase64 } from '../utils/bytes-utils';
export class TokenGenerator {
    constructor(signer) {
        this.signer = signer;
    }
    header() {
        return {
            alg: this.signer.alg,
            typ: 'JWT',
        };
    }
    body(ttl) {
        var _a;
        const nowUtcSeconds = new Date().getTime() / 1000;
        const body = {
            sub: this.signer.subject,
            sub_jwk: (_a = this.signer.subjectPublicKey) === null || _a === void 0 ? void 0 : _a.toString(),
            iat: Math.round(nowUtcSeconds),
            exp: Math.round(nowUtcSeconds + ttl.toMillis() / 1000),
        };
        return body;
    }
    async sign(base64Header, base64Body, signer) {
        const signingPayload = new TextEncoder().encode(base64Header + '.' + base64Body);
        const { payload: signedPayload, signature } = await signer.sign(signingPayload);
        const base64Signature = bytesToBase64(signature);
        return { signedPayload, signature, base64Signature };
    }
}
//# sourceMappingURL=token-generator.js.map